namespace $.$$ {
	
	$mol_style_define( $shm_hitalama_map_widget_float_text, {
		
		userSelect: 'none',

		flex: {
			direction: 'column'
		},

		Blocker: {
			position: 'absolute',
			top: 0,
			right: 0,
			bottom: 0,
			left: 0,
			zIndex: $mol_layer.float,
			pointerEvents: 'auto',
			'[is_button]': {
				true: {
					cursor: 'pointer'
				},
			},
		},

		Image: {
			position: 'absolute',
			width: '100%',
			transition: 'none',
			pointerEvents: 'none',
		},

		Text: {
			position: 'absolute',
			width: '100%',
			background: {
				color: 'transparent',
			},
			font: {
				family: 'inherit',
			},
			$mol_string: {
				background: {
					color: 'transparent',
				},
				boxShadow: 'none',
			},
			lineHeight: '1.5',
			['View' as '$mol_view']: {
				['Row' as '$mol_view']: {
					':empty': {
						height: '1.5em',
					},
					['Token' as '$mol_view']: {
						color: 'inherit',
					},
				},
			},
		},
		Font_size_tool: {
			flex: 'none',
			alignSelf: 'auto',
		},

	} )
	
}
